import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ExcludeWOWithCeroPrice = ({ selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation('bulk');
  return (
    <FormControlLabel
      sx={{ marginLeft: 'unset' }}
      control={
        <Checkbox
          onChange={e =>
            setSelectedFilters(state => ({
              ...state,
              excludeWo: e.target.checked,
            }))
          }
          checked={selectedFilters.excludeWo}
          inputProps={{
            'data-testid': 'excludeWorkOrderCheckbox',
          }}
        />
      }
      label={t('excludeZero')}
    />
  );
};

export default ExcludeWOWithCeroPrice;
